import React from 'react';
import mainTpl from '../templates/installment_from_statement';
import Model from '../models/installmentFromStatement.m';
import BaseNewCardView from '../../Cards/views/BaseNewCardView';
import {apiback} from '../../../config';

const installment_from_statement = 'installment_from_statement_two';

export default class extends BaseNewCardView {
    template = mainTpl;

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            ui: this.uiStates.INITIAL,
            model: {},
            tab: 'get-services',
            selectedType: installment_from_statement
        };
    }

    componentWillMount() {
        fetch(apiback('PAYMENT_INSTALLMENT_FROM_STATEMENT'))
            .then(response => response.json())
            .then(json =>
                this.setState({
                    model: new Model(json.data, this.state.selectedType)
                })
            );
    }

    static displayName = 'InstallmentFromStatement.Views.Main';
}
